/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Section_ProductionInputs */

const vi_tea_purchase_section_production = /** @type {(inputs: Tea_Purchase_Section_ProductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin sản xuất`)
};

/**

* @param {Tea_Purchase_Section_ProductionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_section_production = /** @type {((inputs?: Tea_Purchase_Section_ProductionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Section_ProductionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_section_production(inputs)
});